import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as User from "api/admin/User";

export class Store {
  @observable.ref
  public loading = false;

  @observable.ref
  public users: User.IndexResponse[] = [];

  @action.bound
  public async fetchUsers() {
    this.loading = true;

    const response = await User.Api.index();
    if (response && response.status === Api.Status.OK) {
      this.users = response.data;
    }

    this.loading = false;
  }
}

const Context = React.createContext<Store | null>(null);

export const StoreProvider: React.FC<{ value?: Store }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new Store()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useStore = () => {
  const store = React.useContext(Context);
  if (!store) {
    throw new Error("useStore must be used within a StoreProvider.");
  }
  return store;
};
